import React, { useState } from "react";

import { Trans } from "react-i18next";
import {
  Button,
  ButtonGroup,
  Callout,
  Alert,
  FormGroup,
  InputGroup,
  Popover,
  Tooltip,
} from "@blueprintjs/core";

import { authenticatedPostFetch } from "../../utils/AuthenticatedFetch";
import { getSetting } from "../Settings/InstallationSettings";

export function CmdEquipmentOpen(props) {
  const [alertOpen, openAlert] = useState(false);
  const [justification, setJustification] = useState("");

  return (
    <span>
      <Tooltip content={<Trans>send open comand</Trans>}>
        <Button
          icon="drawer-left"
          onClick={(e) => {
            e.stopPropagation();
            if (getSetting("justify barrier opening")) openAlert(true);
            else
              authenticatedPostFetch("/device/open", {
                srv: props.srv,
                parkId: props.npk,
                deviceId: props.neq,
              });
          }}
        />
      </Tooltip>
      <Alert
        intent="primary"
        isOpen={alertOpen}
        onClose={() => openAlert(false)}
        cancelButtonText={<Trans>cancel</Trans>}
        confirmButtonText={<Trans>send</Trans>}
        icon="help"
        onConfirm={() =>
          authenticatedPostFetch("/device/open", {
            srv: props.srv,
            parkId: props.npk,
            deviceId: props.neq,
            justification: justification,
          })
        }
      >
        <FormGroup
          label={<Trans>please explain this action:</Trans>}
          helperText={
            <Trans>
              this action will be registered and visible by the administrator
            </Trans>
          }
          labelFor="justify"
        >
          <InputGroup
            type="text"
            id="justify"
            value={justification}
            onChange={(ti) => {
              setJustification(ti.target.value);
            }}
          />
        </FormGroup>
      </Alert>
    </span>
  );
}

export function LockButton(props) {
  const [alertOBM, openOBMAlert] = useState(false);
  const [justificationOBM, setJustificationOBM] = useState("");

  let lockedLocally =
    props.equipment.bo !== undefined &&
    props.equipment.bo.Verrou_Pompier !== undefined &&
    props.equipment.bo.Verrou_Pompier !== 0;

  const ret = [];
  if (lockedLocally)
    ret.push(
      <Callout intent="danger" key={"ll" + props.equipment.general.id}>
        <Trans>device locked locally</Trans>
      </Callout>
    );

  if (
    ["L", "l", "p", "E", "S", "C"].includes(props.equipment.general.type) &&
    props.equipment.general.lock === 0
  )
    ret.push(
      <Button
        disabled={lockedLocally}
        key={"lock" + props.equipment.general.id}
        text={<Trans>lock</Trans>}
        icon="lock"
        onClick={(e) => {
          e.stopPropagation();
          authenticatedPostFetch("/device/lock", {
            srv: props.srv,
            parkId: props.equipment.general.parc,
            deviceId: props.equipment.general.id,
          });
        }}
      />
    );

  if (
    ["L", "l", "p", "E", "S"].includes(props.equipment.general.type) &&
    props.equipment.general.lock === 0
  )
    ret.push(
      <span key={"OBM" + props.equipment.general.id}>
        <Button
          disabled={lockedLocally}
          text={<Trans>OBM</Trans>}
          rightIcon="lock"
          onClick={(e) => {
            e.stopPropagation();
            if (getSetting("justify barrier opening")) openOBMAlert(true);
            else
              authenticatedPostFetch("/device/lockopen", {
                srv: props.srv,
                parkId: props.equipment.general.parc,
                deviceId: props.equipment.general.id,
                justification: justificationOBM,
              });
          }}
        />
        <Alert
          intent="primary"
          isOpen={alertOBM}
          onClose={() => openOBMAlert(false)}
          cancelButtonText={<Trans>cancel</Trans>}
          confirmButtonText={<Trans>send</Trans>}
          icon="help"
          onConfirm={() =>
            authenticatedPostFetch("/device/lockopen", {
              srv: props.srv,
              parkId: props.equipment.general.parc,
              deviceId: props.equipment.general.id,
            })
          }
        >
          <FormGroup
            label={<Trans>please explain this action:</Trans>}
            helperText={
              <Trans>
                this action will be registered and visible by the administrator
              </Trans>
            }
            labelFor="justify"
          >
            <InputGroup
              type="text"
              id="justify"
              value={justificationOBM}
              onChange={(ti) => {
                setJustificationOBM(ti.target.value);
              }}
            />
          </FormGroup>
        </Alert>
      </span>
    );

  if (
    ["L", "l", "p", "E", "S", "C"].includes(props.equipment.general.type) &&
    props.equipment.general.lock !== 0
  )
    ret.push(
      <Button
        disabled={lockedLocally}
        key={"unlock" + props.equipment.general.id}
        text={<Trans>unlock</Trans>}
        rightIcon="unlock"
        onClick={(e) => {
          e.stopPropagation();
          authenticatedPostFetch("/device/unlock", {
            srv: props.srv,
            parkId: props.equipment.general.parc,
            deviceId: props.equipment.general.id,
          });
        }}
      />
    );

  return ret.length > 0 ? (
    <Popover
      interactionKind="hover"
      hoverOpenDelay={0}
      hoverCloseDelay={500} // une pensée pour nos anciens un peu fatigués
      content={<ButtonGroup vertical={true}>{ret}</ButtonGroup>}
      placement={"right-start"}
    >
      <Button
        icon="lock"
        intent={
          props.equipment.general.lock > 0 || lockedLocally ? "danger" : "none"
        }
        onClick={(e) => e.stopPropagation()}
      />
    </Popover>
  ) : null;
}

export function ResetButton(props) {
  const [alertReset, openResetAlert] = useState(false);
  const [justificationReset, setJustificationReset] = useState("");

  if (
    ["L", "l", "p", "E", "S", "C"].includes(props.equipment.general.type) &&
    props.equipment.general.connected
  )
    return (
      <span>
        <Tooltip content={<Trans>reset device</Trans>}>
          <Button
            icon="reset"
            onClick={(e) => {
              e.stopPropagation();
              openResetAlert(true);
            }}
          />
        </Tooltip>
        <Alert
          intent="primary"
          isOpen={alertReset}
          onClose={() => openResetAlert(false)}
          cancelButtonText={<Trans>cancel</Trans>}
          confirmButtonText={<Trans>send</Trans>}
          icon="help"
          onConfirm={() =>
            authenticatedPostFetch("/device/reset", {
              srv: props.srv,
              parkId: props.equipment.general.parc,
              deviceId: props.equipment.general.id,
            })
          }
        >
          <FormGroup
            label={<Trans>please explain this action:</Trans>}
            helperText={
              <Trans>
                this action will be registered and visible by the administrator
              </Trans>
            }
            labelFor="justify"
          >
            <InputGroup
              type="text"
              id="justify"
              value={justificationReset}
              onChange={(ti) => {
                setJustificationReset(ti.target.value);
              }}
            />
          </FormGroup>
          <Callout intent="danger">
            <Trans>
              this device will be out of order during reset procedure
            </Trans>
          </Callout>
        </Alert>
      </span>
    );
  else return null;
}
